import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Layout } from "./components";
import { Home, Terms, Privacy } from "./pages";

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};
